define(["data/config", "componentClasses/popover"], function(config, Popover) {
    return {
        name: "tooltip",
        defaultParameters: {
            persist: false,
            wrap: true
        },
        apply: function($element, params) {

            var originalTitle = $element.attr("title")
                ? $element.attr("title")
                : "";

            if (!params.html && !params.url && !params.target) {
                params.html = originalTitle;
            }

            var timeout = function() {};
            params.origin = $element;

            $element.on("mouseleave", function() {
                clearTimeout(timeout);
                $element.attr("title", originalTitle);
            });
            $element.on("mouseenter ontouchstart", function() {
                $element.attr("title", "");
                timeout = setTimeout(function() {
                    var popover = new Popover(params);
                    popover._clearAllPopovers();
                    popover.place();
                }, 200);
            });
        }
    };
});
